import script from "./ImpostorDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpostorDetail.vue?vue&type=script&setup=true&lang=js"

import "./ImpostorDetail.vue?vue&type=style&index=0&id=3eb60658&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb60658"]])

export default __exports__